import React from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

import {
  Button,
  Form,
} from "scenes/Authentication/components/ForgotPasswordManager/components";

export function ForgotPasswordForm({ loading, onSubmit }) {
  const forgotPasswordSchema = yup.object({
    email: yup.string().email("Email is invalid").required("Email is required"),
  });

  const formProps = useForm({
    resolver: yupResolver(forgotPasswordSchema),
    mode: "onSubmit",
    defaultValues: { email: "" },
  });

  return (
    <Form {...formProps} onSubmit={onSubmit}>
      <div style={{ marginTop: "22px" }}>
        <Form.Input
          name="email"
          label="Email"
          fluid
          placeholder="Enter your email"
        />
      </div>
      <Button
        primary
        fluid
        loading={loading}
        disabled={loading}
        style={{ marginTop: "22px" }}
      >
        Send Verification Code
      </Button>
    </Form>
  );
}

ForgotPasswordForm.propTypes = {
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

ForgotPasswordForm.defaultProps = {
  loading: false,
};

export default ForgotPasswordForm;
